import styled from "styled-components";

export const Contenedor = styled.div`
padding: 15px;
width: 100%;
height: 40%;
display: grid;
gap: 20px;
//background: #eef3f5;
background: #f2f4e5;
//background: #212E36;
margin: 10px 0;
border-radius: 20px;
box-shadow: 0px 0px 10px rgba(129, 129, 129, 0.7);
`;

